import React from 'react';
import { Button, Typography } from '@material-ui/core';
import useKixieTestRunner from './useTestRunner/useKixieTestRunner';
import RegionResult from './RegionResult/RegionResult';
import { Region } from '../types';

interface KixieNetworkTestWidgetProps {
  getVoiceToken: () => Promise<string>;
  token?: string;
  iceServers?: RTCIceServer[];
  onComplete: (results: any) => void;
  regions: Region[];
}

export default function KixieNetworkTestWidget({ getVoiceToken, onComplete, regions }: KixieNetworkTestWidgetProps) {
  const { isRunning, results, activeRegion, runTests, activeTest } = useKixieTestRunner();

  async function startTest() {
    const testResults = await runTests(getVoiceToken, regions);
    onComplete(testResults);
  }

  return (
    <div>
      <Typography variant="h4" style={{ marginBottom: '0.5em', textAlign: 'center' }}>
        Kixie Connectivity and Bandwidth Tests
      </Typography>
      {(isRunning || results.length > 0) && (
        <div>
          {regions.map((region, i) => (
            <RegionResult
              key={region}
              region={region}
              isActive={activeRegion === region}
              result={results[i]}
              activeTest={activeTest}
            />
          ))}
        </div>
      )}
      <Button onClick={startTest} variant="contained" color="secondary" disabled={isRunning}>
        Start
      </Button>
    </div>
  );
}
